import { LANDSCAPE_ANGLES } from './constants';

export const isLandscape = () => LANDSCAPE_ANGLES.includes(screen?.orientation?.angle ?? 0);
